var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdPanel",
    [
      _c(
        "EmdPanelSection",
        { attrs: { title: _vm.$t("recipients.create.identification") } },
        [
          _c(
            "EmdFormGroup",
            {
              attrs: {
                label: _vm.$t("recipients.create.type"),
                required: _vm.canEdit,
              },
            },
            [
              _vm.canEdit
                ? _c(
                    "div",
                    { staticClass: "eu-mt_2" },
                    [
                      _c("EmdRadio", {
                        staticClass: "eu-mr_4 eu-mb_2",
                        attrs: {
                          label: _vm.$t("recipients.create.type_individual"),
                          id: "recipient_type_individual",
                          name: "recipient_type",
                          value: "individual",
                        },
                        on: { change: _vm.handleChangeType },
                        model: {
                          value: _vm.recipient.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.recipient, "type", $$v)
                          },
                          expression: "recipient.type",
                        },
                      }),
                      _c("EmdRadio", {
                        staticClass: "eu-mb_2",
                        attrs: {
                          label: _vm.$t("recipients.create.type_company"),
                          id: "recipient_type_company",
                          name: "recipient_type",
                          value: _vm.canCreateRecipient
                            ? "company"
                            : "corporation",
                        },
                        on: { change: _vm.handleChangeType },
                        model: {
                          value: _vm.recipient.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.recipient, "type", $$v)
                          },
                          expression: "recipient.type",
                        },
                      }),
                    ],
                    1
                  )
                : _c("span", [_vm._v(_vm._s(_vm.recipientType))]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }